import axios from "axios";

class TokenService {
  static async getAccessToken() {
    const clientId = process.env.REACT_APP_FORGE_CLIENT_ID;
    const clientSecret = process.env.REACT_APP_FORGE_CLIENT_SECRET;

    if (!clientId || !clientSecret) {
      throw new Error(
        "Forge credentials not found in environment variables. Please check your .env file."
      );
    }

    try {
      const response = await axios.post(
        "https://developer.api.autodesk.com/authentication/v2/token",
        new URLSearchParams({
          client_id: clientId,
          client_secret: clientSecret,
          grant_type: "client_credentials",
          scope: "data:read data:write data:create bucket:create bucket:read",
          // scope: "viewables:read",
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      return {
        access_token: response.data.access_token,
        token_type: response.data.token_type,
        expires_in: response.data.expires_in,
      };
    } catch (error) {
      const errorMessage =
        error.response?.data?.error_description ||
        error.response?.data?.message ||
        error.message ||
        "Unknown error occurred";
      throw new Error(`Authentication failed: ${errorMessage}`);
    }
  }

  static getStoredToken() {
    try {
      const tokenData = localStorage.getItem("forge_token");
      if (!tokenData) return null;

      const parsed = JSON.parse(tokenData);
      const now = Date.now();

      // Check if token is expired (with 5 minute buffer)
      if (now >= parsed.expiresAt - 300000) {
        localStorage.removeItem("forge_token");
        return null;
      }

      return parsed.access_token;
    } catch (error) {
      localStorage.removeItem("forge_token");
      return null;
    }
  }

  static storeToken(tokenData) {
    try {
      const expiresAt = Date.now() + tokenData.expires_in * 1000;

      const tokenInfo = {
        access_token: tokenData.access_token,
        token_type: tokenData.token_type,
        expiresAt: expiresAt,
        obtainedAt: Date.now(),
      };

      localStorage.setItem("forge_token", JSON.stringify(tokenInfo));
    } catch (error) {
      console.error("Failed to store token:", error);
    }
  }

  static clearToken() {
    localStorage.removeItem("forge_token");
  }

  static getTokenExpiry() {
    try {
      const tokenData = localStorage.getItem("forge_token");
      if (!tokenData) return null;

      const parsed = JSON.parse(tokenData);
      return new Date(parsed.expiresAt);
    } catch (error) {
      return null;
    }
  }
}

export default TokenService;
